$(function() {

    if($('[data-pieChart]').lenght <= 0) { return; }

    drawCharts();

    //Reload the pieChart when tab become active (to correct the percentage possition)
    $('.nav-tabs a').on('click', () => {
        setTimeout(() => {
            drawCharts();
        }, 200);
    });
    
    
})

function drawCharts() {
    let chartsToDraw = [];
    $('[data-pieChart]').each(function() {

        let setting = JSON.parse($(this).attr('data-pieChart'));
        setting.element = $(this);
        chartsToDraw.push(setting)
    });

    const googlePieChart = new GooglePieChart(chartsToDraw);
}

class GooglePieChart {

    constructor(chartsToDraw) {

        const pieChartObject = this;

        $.getScript('https://www.gstatic.com/charts/loader.js', function() 
        {
            google.charts.load('current', {'packages':['corechart']});
            google.charts.setOnLoadCallback(function() {
                chartsToDraw.forEach(setting => {
                    pieChartObject.drawChart(Object.entries(setting.array), setting.element, setting.options, setting.arrayHeader);
                });
            });
        });
    }    


     drawChart(array, element, options = {}, arrayHeader = ['header', 'value']) 
     {
         const data = google.visualization.arrayToDataTable([
             arrayHeader,
             ...array
         ]);

     
         // Optional; add a title and set the width and height of the chart
         const defaultOptions = {
             'title': '', 
             'titleTextStyle': {
                 'bold': false,
                 'italic': false,
             },
             'colors': [
                 '#E54027', '#EE8C37', '#234586', '#5cad48',
             ],
             'fontName': 'Open Sans',
             'legend': {
                 'position': 'right',
                 'alignment': 'center'
             },
             'tooltip': {
                 'text': 'both',
             },
             'chartArea': {
                 'top': 0,
                 'bottom': 0,
                 'left': 0,
                 'right': 0,
             },
             'width': 600, 
             'height': 230
         };

         options = Object.assign(defaultOptions, options);
     
         const chart = new google.visualization.PieChart(element[0]);
         chart.draw(data, options);
     }

}